module.exports = "/*\r\n*********************\r\n**    BOOTSTRAP    **\r\n*********************\r\n*/\n:root {\n  --navbar-toggle-border-color: darken(#a82339, 10%); }\n#btn-maquinas-carentes {\n  color: #a82339;\n  color: var(--tertiaryColor); }\n#btn-maquinas-carentes .badge {\n    background-color: #a82339;\n    background-color: var(--tertiaryColor); }\nchart {\n  display: block; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/extratos/dashboard-extratos/dashboard-extratos.component.scss
// module id = ./src/app/extratos/dashboard-extratos/dashboard-extratos.component.scss
// module chunks = main